import {Pipe, PipeTransform} from '@angular/core';
import {timer} from 'rxjs';
import {map} from 'rxjs/operators';

@Pipe({
  name: 'countdown'
})
export class CountdownPipe implements PipeTransform {
  deadline: any;
  value: string;
  source: any;
  subscribe: any;

  getMilisec(date) {
    const splitData = date.split('-');
    let temp = '';
    temp = splitData[1];
    splitData[1] = splitData[0];
    splitData[0] = temp;
    return new Date(splitData[0] + '/' + splitData[1] + '/' + splitData[2]);
  }

  transform(value: any, args?: any): any {
    if (args) {
      const deadline = new Date(this.getMilisec(args.StartDate)).getTime();
      this.source = timer(1000, 1000);
      this.subscribe = this.source.subscribe(val => {
        localStorage.setItem('count', val);
        const now = new Date(this.getMilisec(args.CurrentTime)).getTime() + (1000 * val);
        // const serverTime = new Date(this.getMilisec(args.CurrentTime)).getTime();
        // const localTime = new Date().getTime();
        // let now: number;
        // let differenceTime = 0;
        // if (serverTime < localTime) {
        //   differenceTime = localTime - serverTime;
        //   now = localTime - differenceTime;
        // } else {
        //   differenceTime = serverTime - localTime;
        //   now = localTime + differenceTime;
        // }
        // const now = new Date().getTime();
        // const now = new Date(this.getMilisec(args.CurrentTime)).getTime();
        const t = (deadline - now) - 3600000;
        const days = Math.floor(t / (1000 * 60 * 60 * 24));
        const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((t % (1000 * 60)) / 1000);
        if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
          return 'completed';
        } else {
          let temp = '';
          if (days.toString().length === 1) {
            temp = '0' + days + 'D : ';
          } else {
            temp = days + 'D : ';
          }
          if (hours.toString().length === 1) {
            temp += '0' + hours + 'H : ';
          } else {
            temp += hours + 'H : ';
          }
          if (minutes.toString().length === 1) {
            temp += '0' + minutes + 'M : ';
          } else {
            temp += minutes + 'M : ';
          }
          if (seconds.toString().length === 1) {
            temp += '0' + seconds + 'S ';
          } else {
            temp += seconds + 'S ';
          }
          return args.bindText = temp;
        }
      });
      return args.bindText;
    }
  }
}
